import peopleFill from '@iconify/icons-eva/people-fill';
import pieChart2Fill from '@iconify/icons-eva/pie-chart-2-fill';
import clubIcon from '@iconify/icons-ic/baseline-account-balance';
import expolreIcon from '@iconify/icons-ic/baseline-travel-explore';
import airplainIcon from '@iconify/icons-ic/outline-airplanemode-active';
import flightList from '@iconify/icons-ic/sharp-list-alt';
import unlockFill from '@iconify/icons-eva/unlock-fill';
import globeFill from '@iconify/icons-eva/globe-3-fill';
import { Icon } from '@iconify/react';

// ----------------------------------------------------------------------

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

const sidebarConfig = [
  {
    title: 'dashboard',
    path: '/dashboard',
    icon: getIcon(pieChart2Fill)
  },
  {
    title: 'liveMap',
    path: '/live/map',
    icon: getIcon(expolreIcon)
  },
  {
    title: 'flightsList',
    path: '/flight/list',
    icon: getIcon(flightList)
  },
  {
    title: 'reportClub',
    path: '/report/club',
    icon: getIcon('tabler:report-analytics')
  },
  {
    title: 'clubsList',
    path: '/club',
    icon: getIcon(clubIcon)
  },
  {
    title: 'devicesList',
    path: '/device',
    icon: getIcon(airplainIcon)
  },
  {
    title: 'usersList',
    path: '/user',
    icon: getIcon(peopleFill)
  },
  {
    title: 'geofences',
    path: '/geofences',
    icon: getIcon(globeFill)
  },
  {
    title: 'liveReport',
    path: '/live/report',
    icon: getIcon(flightList)
  },
  { title: 'aerosList', path: '/aeros', icon: getIcon('mdi:airport'), isActive: false },
  {
    title: 'sub',
    path: '/subscription/plans',
    icon: getIcon(unlockFill)
  }
];

export default sidebarConfig;
